// extracted by mini-css-extract-plugin
module.exports = {"navItem":"WhatsNewButton_navItem__O52LF","navItemInner":"WhatsNewButton_navItemInner__RCWXD"};